export const SIDEBAR_WIDTH = 256;

export const COLLAPSED_SIDEBAR_WIDTH = 56;